 
import type { OrderNoteType } from '../enums/OrderNoteType'
import type { OrderUserEntity } from './OrderUserEntity'

export class NoteMiniEntity {
  id?: string
  orderId?: string
  note?: string | null
  adminUser?: OrderUserEntity
  adminType?: OrderNoteType
  createdAt?: string
  updatedAt?: string
}
